import { createSlice } from "@reduxjs/toolkit";
import { uploadedPharmacyDoc } from "../../reducer/uploadedPharmacyDocuments/uploadedPharReducer";

//default value
const initialState = {
  data: {},
  loading: false,
  error: null,
};

const pharmacyDocumentsSlice = createSlice({
  name: "doctorDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadedPharmacyDoc.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(uploadedPharmacyDoc.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(uploadedPharmacyDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default pharmacyDocumentsSlice.reducer;
